import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
import RewardSupplierCollection from "src/shared/collections/BuiltRewardSupplierCollection";

function getRewardSupplierId(model) {
    return model.get("reward_supplier_id");
}

function buildUrl(webhookId) {
    return `/api/v4/webhooks/reward/${webhookId}/filters/supplier`;
}

const RewardSupplierFilterModel = Backbone.Model.extend({
    initialize(attributes, options) {
        this.webhookId =
            options.webhookId || this.collection.rewardWebhookModel.id;
    },
    urlRoot() {
        return buildUrl(this.webhookId);
    },
});

const RewardSupplierFilterCollection = Backbone.Collection.extend({
    model: RewardSupplierFilterModel,

    url() {
        return buildUrl(this.rewardWebhookModel.id);
    },

    initialize(attributes, options) {
        this.rewardWebhookModel = options.rewardWebhookModel;
    },

    getFilterName() {
        return "reward_supplier_id_filter";
    },

    fetch() {
        if (
            this.rewardWebhookModel.isNew() ||
            this.rewardWebhookModel.get("type") === "GENERIC"
        ) {
            const deferred = $.Deferred();
            return deferred.resolve([]);
        }

        return Backbone.Collection.prototype.fetch.call(this);
    },

    loadItems() {
        const self = this;
        const deferred = $.Deferred();
        const rewardSupplierCollection = RewardSupplierCollection.create();

        $.when(this.fetch(), rewardSupplierCollection.fetch()).done(() => {
            const selectedIds = self.map(getRewardSupplierId);
            const allItems = rewardSupplierCollection.map((rewardSupplier) => {
                const rewardSupplierId = rewardSupplier.id;
                return {
                    id: rewardSupplierId,
                    value: rewardSupplier.get("name"),
                    isSelected: _.contains(selectedIds, rewardSupplierId),
                };
            });

            self.rewardWebhookModel.set(self.getFilterName(), selectedIds);
            deferred.resolve(allItems);
        });

        return deferred;
    },

    save() {
        const self = this;
        const deferred = $.Deferred();
        const rewardSupplierIds =
            this.rewardWebhookModel.get(this.getFilterName()) || [];
        const createPromises = this.getCreatePromises(rewardSupplierIds);
        const deletedPromises = this.getDeletePromises(rewardSupplierIds);
        const promises = _.union(createPromises, deletedPromises);

        $.when
            .apply($, promises)
            .done(() => {
                $.when(self.fetch()).always(deferred.resolve);
                deferred.resolve();
            })
            .fail(deferred.reject);

        return deferred;
    },

    getCreatePromises(rewardSupplierIds) {
        return _.difference(
            rewardSupplierIds,
            this.map(getRewardSupplierId)
        ).map(this.createNewFilter.bind(this));
    },

    getDeletePromises(rewardSupplierIds) {
        return this.filter(
            (filter) =>
                !_.contains(rewardSupplierIds, filter.get("reward_supplier_id"))
        ).map((filter) => filter.destroy());
    },

    createNewFilter(rewardSupplierId) {
        return new RewardSupplierFilterModel(
            {
                reward_supplier_id: rewardSupplierId,
            },
            { webhookId: this.rewardWebhookModel.id }
        ).save();
    },
});

RewardSupplierFilterCollection.create = function (rewardWebhookModel) {
    return new RewardSupplierFilterCollection(
        {},
        {
            rewardWebhookModel,
        }
    );
};

export default RewardSupplierFilterCollection;
